import AppRoutes from "./routes/index";
function App() {
  return (
    <>
      <AppRoutes />
    </>
  );
}

export default App;
